import { ev } from "../util";

export enum TransactionType {
    SUBSCRIBE = ev('SUBSCRIBE', 1),
    RECURRING = ev('RECURRING', 2),
    REPLACE_MANDATE = ev('REPLACE_MANDATE', 3),
    PAYMENT_LINK = ev('PAYMENT_LINK', 4),
    UPGRADE = ev('UPGRADE', 5)
}
